<template>
  <div class="pa-4">
    <v-card class="mt-2 py-2">
      <v-toolbar flat>
        <v-toolbar-title>{{$route.name}}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn color="grey" dark class="mb-2 mr-2" @click="goBack" small>
          <v-icon small>mdi-arrow-left</v-icon>
          Back
        </v-btn>
      </v-toolbar>

      <div class="mt-3">
        <v-row class="mx-5 py-0" align="center">
          <v-col cols="2">Order ID</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ order.order_id || '-' }}</div></v-col>
          <v-col cols="2">Group</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ selectedGroupLabel }}</div></v-col>
        </v-row>

        <v-row class="mx-5 py-0" align="center">
          <v-col cols="2">Hari Kirim</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ formatDate(order.delivery_date) }}</div></v-col>
          <v-col cols="2">Koordinator</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ coordinatorLabel }}</div></v-col>
        </v-row>

        <v-row class="mx-5 py-0" align="center">
          <v-col cols="2">Tanggal Expired</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ formatDate(order.expired_date) }}</div></v-col>
          <v-col cols="2">Additional Order</v-col>
          <v-col cols="4"><div class="compact-form-text">{{ order.is_additional ? 'Ya' : 'Tidak' }}</div></v-col>
        </v-row>

        <v-row class="mx-5 py-0" align="center">
          <v-col cols="2">Remarks</v-col>
          <v-col cols="10"><div class="compact-form-text">{{ order.remarks || '-' }}</div></v-col>
        </v-row>

        <v-card outlined class="ma-3 mt-5" width="800px">
          <v-simple-table fixed-header fixed-footer height="350px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Code</th>
                  <th class="text-left">Volume</th>
                  <th class="text-left">Variant</th>
                  <th class="text-left">Total</th>
                  <th class="text-left">Adjustment</th>
                  <th class="text-left">Aktual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, vidx) in filteredOrderDetails" :key="vidx">
                  <td>{{ item.variant ? item.variant.code : item.variant_code }}</td>
                  <td>{{ item.variant && item.variant.size ? `${item.variant.size} ml` : '-' }}</td>
                  <td>{{ item.variant ? item.variant.name : '-' }}</td>
                  <td>{{ item.qty_initial }}</td>
                  <td>{{ item.qty_adjustment }}</td>
                  <td>{{ item.qty_ordered }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="text-center" colspan="3">TOTAL</th>
                  <th class="text-left">{{ calculatedTotalInitial }}</th>
                  <th class="text-left">{{ calculatedTotalAdjustment }}</th>
                  <th class="text-left">{{ calculatedTotalActual }}</th>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </v-card>
      </div>

      <v-overlay :value="onProgress" z-index="999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      groups: null,
      selectedGroup: null,
      coordinators: null,
      variants: null,
      onProgress: false,
      order: {
        order_batch: "",
        order_id: "",
        production_date: null,
        delivery_date: null,
        expired_date: null,
        coordinator_code: null,
        remarks: "",
        status: 0,
        order_category: "",
        order_details: []
      },
      filteredOrderDetails: []
    }
  },
  computed: {
    selectedGroupLabel() {
      return this.selectedGroup ? this.selectedGroup.description : '-'
    },
    coordinatorLabel() {
      const found = (this.coordinators || []).find(c => String(c.code) === String(this.order.coordinator_code))
      return found ? found.name : '-'
    },
    calculatedTotalInitial() {
      return (this.order.order_details || []).reduce((sum, item) => sum + Number(item.qty_initial || 0), 0)
    },
    calculatedTotalAdjustment() {
      return (this.order.order_details || []).reduce((sum, item) => sum + Number(item.qty_adjustment || 0), 0)
    },
    calculatedTotalActual() {
      return (this.order.order_details || []).reduce((sum, item) => sum + Number(item.qty_ordered || 0), 0)
    },
  },
  async created() {
    this.onProgress = true
    try {
      this.order.order_batch = this.$route.params.batch
      const [groupsRes, variantsRes, coordinatorsRes] = await Promise.all([
        this.$store.dispatch('ordercategory/getObjs'),
        this.$store.dispatch('variant/getObjs'),
        this.$store.dispatch('coordinator/getObjs')
      ])
      this.groups = groupsRes?.data?.data
      this.variants = variantsRes?.data?.data
      this.coordinators = coordinatorsRes?.data?.data

      const order_id = this.$route.params.order_id
      await this.loadOrder(order_id)
      this.filteredOrderDetails = this.order.order_details
    } catch (error) {
      console.error('Failed to load order plan data:', error)
    } finally {
      this.onProgress = false
    }
  },
  methods: {
    goBack() {
      const from = this.$route.query.from
      const allowedPaths = ['/orderplanningprod', '/requestplanningprod']
      const safePath = from && allowedPaths.some(p => from.startsWith(p)) ? from : '/orderplanningprod'
      this.$router.push(safePath)
    },
    formatDate(date) {
      if (!date) return '-'
      return moment(date).format('ddd, D MMM YYYY')
    },
    cleanObj(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') {
          this.cleanObj(obj[key])
        } else if (obj[key] === null) {
          delete obj[key]
        }
      })
    },
    async loadOrder(order_id) {
      const response = await this.$store.dispatch('getObjs', {apidomain:'orders?fields[order_id]=', parameter:order_id})
      const order = response?.data?.data?.[0]
      if (!order) {
        console.error('Order not found:', order_id)
        return
      }
      order.order_details = order.details
      delete order.details
      this.order = JSON.parse(JSON.stringify(order))

      this.selectedGroup = (this.groups || []).find(el => this.order.order_category == el.code)
      this.order.order_details.forEach(element => {
        const variant = (this.variants || []).find(el => el.code === element.variant_code)
        element.variant = variant
        element.qty_adjustment = element.qty_adjustment || 0
        element.qty_initial = Number(element.qty_ordered) - Number(element.qty_adjustment)
        this.cleanObj(element)
      })
      this.order.order_details.sort((a, b) => {
        const sizeA = parseFloat(a.variant?.size || 0)
        const sizeB = parseFloat(b.variant?.size || 0)
        if (sizeA !== sizeB) return sizeA - sizeB
        return (a.variant?.sort_no || 0) - (b.variant?.sort_no || 0)
      })
    }
  }
}
</script>

<style>
.compact-form-text {
  padding: 8px 12px;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 7px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.v-data-table table tfoot th
{
  position: sticky;
  bottom: 0;
  background: #FFF;
}
</style>